import React from 'react';
import './Rightcpallet.css';
import RighPa from '../../../imgs/RighPall.webp';

const Rightcpallet = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Choosing The Right Plastic Pallet Injection Molding Machine</h2>

                <div className="Rightcpal">
                    <img src={RighPa} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <p className="Material-text">DP1500-S6, DP1800-S6, DP2100-S6, DP2500-S6,
                     DP2900-S6, DP3300-S6 These production cases are for reference only,
                     please feel free to contact us for details!</p>

            </div>
        </div>
    );
};
export default Rightcpallet;
